import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
    const { token, roleType, userId } = useSelector((state) => state.auth);
  
    const Logoutpath = roleType === "superadmin" ? "/admin/login" : "/institutions/login"

  if (!isAuthenticated) {
    return <Navigate  replace />;
  }

  return children;
};

export default ProtectedRoute;
